import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const ValueStreamPerformanceChart = ({ data }) => {
  console.log("🎯 ValueStreamPerformanceChart received:", data);

  // Extract value streams from API response
  const valueStreams = data.value_streams || [];

  // Transform data for chart
  // Handle both old format (metrics) and new format (totals)
  const labels = valueStreams.map(stream => stream.value_stream);
  const sales = valueStreams.map(stream =>
    stream.totals?.revenue || stream.metrics?.total_revenue || 0
  );
  const profit = valueStreams.map(stream =>
    stream.totals?.profit || stream.metrics?.net_profit || 0
  );

  console.log("🎯 Chart data:", { labels, sales, profit });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Sales',
        data: sales,
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderColor: 'rgb(75, 192, 192)',
        borderWidth: 1
      },
      {
        label: 'Profit',
        data: profit,
        backgroundColor: 'rgba(54, 162, 235, 0.7)',
        borderColor: 'rgb(54, 162, 235)',
        borderWidth: 1
      }
    ]
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1.5,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 15
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.x !== null) {
              label += new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0
              }).format(context.parsed.x);
            }
            return label;
          }
        }
      },
      datalabels: {
        display: true,
        align: 'end',
        anchor: 'end',
        formatter: function(value) {
          if (value >= 1000000) {
            return '$' + (value / 1000000).toFixed(1) + 'M';
          } else if (value >= 1000) {
            return '$' + (value / 1000).toFixed(1) + 'K';
          }
          return '$' + value.toFixed(0);
        },
        font: {
          size: 10,
          weight: 'bold'
        },
        color: '#333'
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            if (value >= 1000000) {
              return '$' + (value / 1000000).toFixed(0) + 'M';
            } else if (value >= 1000) {
              return '$' + (value / 1000).toFixed(0) + 'K';
            }
            return '$' + value;
          }
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    }
  };

  // Handle no data case
  if (valueStreams.length === 0) {
    return (
      <div style={{ position: 'relative', height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p className="text-muted">No value stream data available for this period</p>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', height: '350px' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default ValueStreamPerformanceChart;